(() => {
  const bind = (root) => {
    if (root.dataset.bound) return;
    root.dataset.bound = '1';

    const tabs = [...root.querySelectorAll('[data-kc-source]')];
    const notes = [...root.querySelectorAll('[data-kc-note]')];
    const panels = [...root.querySelectorAll('.kit-comparison__panel')];
    if (!tabs.length || !panels.length) return;

    let source = root.dataset.defaultSource || 'city';
    if (/\/collections\/[^/]*well/i.test(location.pathname)) {
      source = 'well';
    } else if (source !== 'well' && source !== 'city') {
      source = 'city';
    }
    const syncers = [];

    const paint = () => {
      tabs.forEach((tab) => {
        const on = tab.dataset.kcSource === source;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-selected', String(on));
        tab.tabIndex = on ? 0 : -1;
      });
      notes.forEach((note) => {
        note.hidden = note.dataset.kcNote !== source;
      });
      panels.forEach((panel) => {
        const on = panel.dataset.kcPanel === source;
        panel.hidden = !on;
      });
      syncers.forEach((fn) => fn());
    };

    const bindScroll = (panel) => {
      const scroller = panel.querySelector('[data-kc-scroll]');
      const progress = panel.querySelector('[data-kc-progress]');
      const thumb = panel.querySelector('[data-kc-progress-thumb]');
      if (!scroller || !progress || !thumb) return;

      const sync = () => {
        if (panel.hidden) return;
        const max = Math.max(0, scroller.scrollWidth - scroller.clientWidth);
        progress.hidden = max <= 0;
        if (max <= 0) return;
        const ratio = scroller.scrollLeft / max;
        const track = progress.clientWidth;
        const thumbW = Math.max(track * 0.28, 48);
        const usable = Math.max(1, track - thumbW);
        thumb.style.width = `${thumbW}px`;
        thumb.style.transform = `translateX(${ratio * usable}px)`;
        thumb.setAttribute('aria-valuenow', String(Math.round(ratio * 100)));
      };

      const scrub = (clientX) => {
        const max = Math.max(0, scroller.scrollWidth - scroller.clientWidth);
        if (max <= 0) return;
        const rect = progress.getBoundingClientRect();
        const thumbW = thumb.offsetWidth || rect.width * 0.28;
        const usable = Math.max(1, rect.width - thumbW);
        const x = Math.min(usable, Math.max(0, clientX - rect.left - thumbW / 2));
        scroller.scrollLeft = (x / usable) * max;
      };

      scroller.addEventListener('scroll', sync, { passive: true });
      syncers.push(sync);

      let dragging = false;
      progress.addEventListener('pointerdown', (e) => {
        dragging = true;
        progress.setPointerCapture(e.pointerId);
        scrub(e.clientX);
        e.preventDefault();
      });
      progress.addEventListener('pointermove', (e) => {
        if (dragging) scrub(e.clientX);
      });
      const endDrag = (e) => {
        if (!dragging) return;
        dragging = false;
        if (progress.hasPointerCapture?.(e.pointerId)) {
          progress.releasePointerCapture(e.pointerId);
        }
      };
      progress.addEventListener('pointerup', endDrag);
      progress.addEventListener('pointercancel', endDrag);

      thumb.addEventListener('keydown', (e) => {
        const max = Math.max(0, scroller.scrollWidth - scroller.clientWidth);
        const step = Math.max(40, scroller.clientWidth * 0.35);
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
          scroller.scrollLeft = Math.min(max, scroller.scrollLeft + step);
          e.preventDefault();
        } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
          scroller.scrollLeft = Math.max(0, scroller.scrollLeft - step);
          e.preventDefault();
        } else if (e.key === 'Home') {
          scroller.scrollLeft = 0;
          e.preventDefault();
        } else if (e.key === 'End') {
          scroller.scrollLeft = max;
          e.preventDefault();
        }
      });
    };

    tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => {
        source = tab.dataset.kcSource;
        paint();
      });
      tab.addEventListener('keydown', (e) => {
        const next =
          e.key === 'ArrowRight' || e.key === 'ArrowDown'
            ? tabs[(i + 1) % tabs.length]
            : e.key === 'ArrowLeft' || e.key === 'ArrowUp'
              ? tabs[(i - 1 + tabs.length) % tabs.length]
              : e.key === 'Home'
                ? tabs[0]
                : e.key === 'End'
                  ? tabs[tabs.length - 1]
                  : null;
        if (!next) return;
        e.preventDefault();
        source = next.dataset.kcSource;
        paint();
        next.focus();
      });
    });

    panels.forEach(bindScroll);
    window.addEventListener('resize', () => syncers.forEach((fn) => fn()), { passive: true });
    paint();
  };

  const init = () => document.querySelectorAll('[data-kit-comparison]').forEach(bind);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (e) => {
    e.target.querySelectorAll?.('[data-kit-comparison]').forEach((el) => {
      delete el.dataset.bound;
      bind(el);
    });
  });
})();
